import React from "react";
import { Grid, MenuItem, Select } from "@mui/material";
import module from "./BirthDaySelect.module.css";

const BirthdaySelect = (props) => {
    const { label, defaultYear, defaultMonth, defaultDay, disabled = null } = props;
    return (
        <Grid item xs={12} sx={{ textAlign: "left", marginBottom: "24px" }}>
            <label className={module.label}>{label || "生年月日"}</label>
            <span className={module.labelRequire}>*</span>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <Select
                        id="birth-year-select"
                        name="birth_year"
                        defaultValue={defaultYear || 1990}
                        fullWidth
                        disabled={disabled}
                    >
                        {Array.from(Array(90).keys()).map((i) => (
                            <MenuItem key={`year_${1920 + i}`} value={1920 + i}>
                                {1920 + i}年
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={4}>
                    <Select
                        id="birth-month-select"
                        name="birth_month"
                        defaultValue={defaultMonth || 4}
                        disabled={disabled}
                        fullWidth
                    >
                        {Array.from(Array(12).keys()).map((i) => (
                            <MenuItem key={`monthly_${1 + i}`} value={1 + i}>
                                {1 + i}月
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
                <Grid item xs={4}>
                    <Select
                        id="birth-day-select"
                        name="birth_day"
                        defaultValue={defaultDay || 15}
                        disabled={disabled}
                        fullWidth
                    >
                        {Array.from(Array(31).keys()).map((i) => (
                            <MenuItem key={`daily_${1 + i}`} value={1 + i}>
                                {1 + i}日
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default BirthdaySelect;
